import { render, staticRenderFns } from "./MaintenanceAboutYou.vue?vue&type=template&id=6d4d07d2&scoped=true"
import script from "./MaintenanceAboutYou.vue?vue&type=script&lang=js"
export * from "./MaintenanceAboutYou.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceAboutYou.vue?vue&type=style&index=0&id=6d4d07d2&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6d4d07d2",
  null
  
)

export default component.exports